import { createSelector, Selector } from 'reselect';
import { initialState as initRootState, RootState } from '@vfde-fe/sails_core';
import { initialState } from './reducer';
import NAMESPACE from './constant';
import { IInitialState, InitRootState } from './interfaces/state';

const selectRootDomain = (state: RootState<InitRootState>) => state.app || initRootState;
const selectOverlayState = (state: RootState<IInitialState>) => state[NAMESPACE] || initialState;

const selectRootOverlayState = (): Selector<RootState<InitRootState>, InitRootState['overlay']> =>
    createSelector(
        selectRootDomain,
        state => state.overlay,
    );
const selectRootOverlayNameState = (): Selector<RootState<InitRootState>, InitRootState['overlayName']> =>
    createSelector(
        selectRootDomain,
        state => state.overlayName,
    );
const selectOverlayLoaded = (): Selector<RootState<IInitialState>, IInitialState['overlayLoaded']> =>
    createSelector(
        selectOverlayState,
        state => state.overlayLoaded,
    );

export {
    selectRootDomain,
    selectRootOverlayState,
    selectRootOverlayNameState,
    selectOverlayLoaded,
};
